import { createFileRoute, Outlet } from '@tanstack/react-router'
import Reports from '../../../../../containers/Reports'

function ReportLayout() {
  const { projectId } = Route.useParams()

  return (
    <>
      <Reports projectId={projectId} />
      <Outlet />
    </>
  )
}

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/reports'
)({
  component: ReportLayout
})
